import { MDBIcon } from "mdbreact";
import React, { useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";

const InputMultipleDropDown = ({
	options,
	label,
	value,
	onBlur,
	onChange,
	name,
	disabled,
	...props
}) => {
	const { t } = useTranslation();
	const [isOpen, setIsOpen] = useState(false);
	const [isChecked, setIsChecked] = useState(
		new Array(options.length).fill(false)
	);
	const [selectedValues, setSelectedValues] = useState([]);

	const DropdownRef = useRef(null);

	useEffect(() => {
		const handleClickOutside = (event) => {
			if (DropdownRef.current && !DropdownRef.current.contains(event.target)) {
				setIsOpen(false);
			}
		};
		document.addEventListener("mousedown", handleClickOutside);
		return () => {
			// Unbind the event listener on clean up
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, [DropdownRef]);

	useEffect(() => {
		console.log("raw date", value);
		const newChecked = new Array(options.length).fill(false);
		value.forEach((ele) => {
			const index = options.findIndex((data) => data == ele);
			if (index != -1) {
				newChecked[index] = true;
			}
		});
		setIsChecked(newChecked);
		setSelectedValues(value);
	}, [value]);
	const ChangeHandler = (index) => {
		const newChecked = [...isChecked];
		newChecked[index] = !newChecked[index];
		const newSelectedValues = [...selectedValues];
		if (newChecked[index]) {
			newSelectedValues.push(options[index]);
		} else {
			newSelectedValues.splice(
				newSelectedValues.findIndex((ele) => ele === options[index]),
				1
			);
		}
		setSelectedValues(newSelectedValues);
		setIsChecked(newChecked);
		onChange({
			target: {
				id: name,
				value: newSelectedValues,
				type: "multipleDropdown",
			},
		});
		onBlur({
			target: {
				id: name,
				value: newSelectedValues,
				type: "multipleDropdown",
			},
		});
	};

	return (
		<div
			className="child-register-multi-field"
			ref={DropdownRef}
		>
			<p
				className="child-register-multi-label"
			>
				{t(label)}{" "}
				{props?.required ? <span className="red-text">*</span> : <span></span>}
			</p>
			<div
				style={{
					backgroundColor: `${disabled ? "#e9ecef" : "white"}`,
				}}
				className="child-register-multi-control"
				onClick={() => (disabled ? null : setIsOpen((state) => !state))}
				role="button"
				tabIndex={disabled ? -1 : 0}
				aria-expanded={isOpen}
			>
				<p className="m-0">
					{selectedValues.length
						? selectedValues.join(",")
						: t("Select An Option")}
				</p>
				<MDBIcon icon={isOpen ? "chevron-up" : "chevron-down"} />
			</div>
			<div
				className="child-register-multi-menu"
				style={{ display: `${isOpen ? "flex" : "none"}` }}
			>
				{options.map((ele, index) => (
					<div
						className="child-register-multi-option"
						key={ele}
					>
						<input
							type="checkbox"
							id={ele}
							checked={isChecked[index]}
							onChange={() => ChangeHandler(index)}
						/>
						<label className="m-0 pl-2" htmlFor={ele}>
							{t(ele)}
						</label>
					</div>
				))}
			</div>
		</div>
	);
};

export default InputMultipleDropDown;
